import { compose } from 'recompose';
import { addProps } from 'utils/recompose';
import { connect } from 'react-redux';
import combineSelectors from 'utils/combineSelectors';

const mapStateToProps = combineSelectors({});
const designOptions = () => [
  'paintOption',
  'interiorOption',
  'trimOption',
  'wheelOption',
];

export default compose(
  connect(
    mapStateToProps,
    {},
  ),
  addProps({
    designOptions,
  }),
);
